import React  from 'react';
import { Admin } from 'admin-on-rest';

import authClient from './api/authClient';
import Dashboard from './pages/Dashboard';
import Menu from './Menu';
import routes from './routes';
import theme from './theme';
import AppBar from './AppBar';
import search from './components/Search/searchReducer';
import conferenceDetail from './pages/ConferenceDetail/conferenceDetailReducer';

const App = () => (
  <Admin        
    customReducers={{ search, conferenceDetail }}
    authClient={ authClient }
    theme={ theme }
    dashboard={ Dashboard }
    customRoutes={ routes }
    menu={ Menu }
    title={ <AppBar/> }>      
  </Admin>
);

export default App;



// WEBPACK FOOTER //
// ./src/App.js